import React from "react";

import {connect} from 'react-redux'
import FormEditor from './components/formEditor'
import {findFieldById} from './schema'
import style from './FieldSettings.scss'
class FieldSettings extends React.Component {

    componentDidMount(){
        const {fieldId} = this.props.match.params;
        fieldId&&this.props.openSettings('options');
    }


    render() {
        const {reduxFields, match, handleChange, editorOpenTabs, switchTab,currentTab} = this.props;
        const {fieldId} = match.params;
        const {field} = findFieldById(fieldId,reduxFields.fields);
        return (
            currentTab=='options'?<div className={style.wrap}>
                {field &&
                <FormEditor
                    openTabs={editorOpenTabs}
                    switchTab={switchTab}
                    handleChange={(f) => {
                        handleChange(f, match.params.sectionId)
                    }}
                    field={field}
                />
                }
            </div>:null
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const $section = ownProps.match.params.sectionId;

    let reduxFields = {fields: []};
    if (typeof  state.fields.data !== "undefined" && typeof  state.fields.data[$section] !== 'undefined') {
        reduxFields = state.fields.data[$section]
    }
    return {
        reduxFields,
    }
}

export default connect(mapStateToProps)(FieldSettings)

